import React from 'react';
import type { FC } from 'react';
import type { DevMetadata } from '@wix/cli-astro-definitions';
import { DevEnvironmentProvider } from './DevEnvironment.js';
import { SiteProvider } from './app-flow/site/index.js';
import { AppDev } from './app-flow/AppDev.js';

interface AppDevFlowProps {
  base?: string;
  serverLocalUrl: string;
  serverExposedUrl?: string;
  devMetadata: DevMetadata | null;
}

export const AppDevFlow: FC<AppDevFlowProps> = (props) => {
  return (
    <SiteProvider>
      {(siteId) => (
        <DevEnvironmentProvider {...props} siteId={siteId}>
          <AppDev />
        </DevEnvironmentProvider>
      )}
    </SiteProvider>
  );
};
